import { RAID_BRIDGE_ENDPOINT } from '../api/raidBridgeApi.js';
import { RAID_BRIDGE_USERSCRIPT_VERSION } from '../api/raidBridgeInstaller.js';
import { useRaidBridge } from '../hooks/useRaidBridge.js';
import { RaidBridgeDirectSync } from '../shared/RaidBridgeDirectSync.jsx';
import { RaidBridgeQuickStart } from '../shared/RaidBridgeQuickStart.jsx';

const MODE_LABELS = { snapshot: '전체 갱신', incremental: '새 기록' };

function formatDateTime(value) {
  if (!value) return '없음';
  try { return new Intl.DateTimeFormat('ko-KR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(value)); }
  catch { return '확인 불가'; }
}

export function MobileRaidBridge() {
  const bridge = useRaidBridge();
  if (!bridge.loading && !bridge.canManage) return null;

  const ready = Boolean(bridge.collectorReady);
  const installerText = bridge.installer.checking
    ? '확인 중'
    : bridge.installer.installed
      ? `설치됨${bridge.installer.version ? ` · v${bridge.installer.version}` : ''}`
      : '미설치';

  const revoke = () => {
    if (window.confirm('현재 유니온 공용 토큰을 해제할까요? 모든 관리자 PC의 수집이 중단됩니다.')) bridge.revoke();
  };
  const statusLabel = bridge.tokenOutdated ? '구형 토큰' : ready ? '수집 가능' : '설정 필요';

  return (
    <section className="mobile-raid-bridge" aria-label="레이드 수집기 관리">
      <header className="mobile-raid-bridge-heading">
        <div><h2>레이드 수집기</h2><p>BlablaLink의 실전 기록, 보스 정보, 현재 멤버 명단을 DoroParty에 반영합니다.</p></div>
        <strong className={ready ? 'ready' : 'setup'}>{statusLabel}</strong>
      </header>

      {bridge.loading ? (
        <div className="mobile-raid-bridge-loading"><span /><p>수집기 상태를 확인하고 있습니다.</p></div>
      ) : (
        <>
          <RaidBridgeQuickStart bridge={bridge} mobile />
          <RaidBridgeDirectSync bridge={bridge} mobile />

          <section className="mobile-raid-bridge-history" aria-label="최근 수집 기록">
            <div className="raid-bridge-section-header"><div><h3>최근 수집 기록</h3><p>최근 5개 결과를 표시합니다.</p></div></div>
            {bridge.recentBatches.length === 0 ? <p className="empty">아직 수집한 기록이 없습니다.</p> : (
              <div className="mobile-raid-bridge-history-list">
                {bridge.recentBatches.slice(0, 5).map((batch) => (
                  <div key={batch.id}>
                    <span>{formatDateTime(batch.createdAt)}</span>
                    <strong>{batch.seasonNo}차 · {MODE_LABELS[batch.mode] || batch.mode}</strong>
                    <small>받음 {batch.recordCount} · 반영 {batch.upsertedCount} · 정리 {batch.removedCount}</small>
                  </div>
                ))}
              </div>
            )}
          </section>

          <details className="mobile-raid-bridge-advanced">
            <summary><span>고급 설정</span><small>연결 정보와 공용 토큰 전체 해제</small></summary>
            <div className="mobile-raid-installer">
              <div className="mobile-raid-installer-head"><div><strong>Tampermonkey 연결 관리</strong><p>연결 정보 확인이나 전체 해제가 필요할 때만 사용하세요.</p></div><em className={bridge.installer.installed ? 'installed' : 'missing'}>{installerText}</em></div>
              <div className="mobile-raid-bridge-endpoint"><span>수신 주소</span><code>{RAID_BRIDGE_ENDPOINT}</code></div>
              {bridge.activeToken ? <div className="mobile-raid-bridge-actions"><button className="revoke" type="button" disabled={Boolean(bridge.working)} onClick={revoke}>{bridge.working === 'revoke' ? '해제 중…' : '공용 토큰 전체 해제'}</button></div> : null}
              <small>필요 수집기 버전 v{RAID_BRIDGE_USERSCRIPT_VERSION}</small>
            </div>
          </details>
        </>
      )}

      {bridge.notice.message ? <p className={`mobile-raid-bridge-notice ${bridge.notice.type}`} role="status">{bridge.notice.message}</p> : null}
    </section>
  );
}
